import DATable from "./da-table/DATable";
import PartnerTable from "./da-table/PartnerTable";

export { DATable, PartnerTable };
